import type { SVGProps } from 'react';

// The prototype's inline symbols (prototype/index.html) as components. Stroke icons,
// currentColor, 24×24 viewBox.
const PATHS = {
  plane: <path d="M16 10h4a2 2 0 1 1 0 4h-4l-4 7h-3l2-7H7l-2 2H2l2-4-2-4h3l2 2h4l-2-7h3z" />,
  back: <path d="M15 5l-7 7 7 7" />,
  cal: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M16 3v4M8 3v4M3 10h18" />
    </>
  ),
  plus: <path d="M12 6v12M6 12h12" />,
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9s1.3-6.4 3.8-9z" />
    </>
  ),
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  scan: (
    <>
      <path d="M4 8V6a2 2 0 0 1 2-2h2" />
      <path d="M16 4h2a2 2 0 0 1 2 2v2" />
      <path d="M20 16v2a2 2 0 0 1-2 2h-2" />
      <path d="M8 20H6a2 2 0 0 1-2-2v-2" />
    </>
  ),
} as const;

const WIDTH: Record<IconName, number> = {
  plane: 1.7,
  back: 2,
  cal: 1.7,
  plus: 2,
  x: 2,
  scan: 1.7,
  globe: 1.7,
  check: 2.2,
};

/** Icons that point along the line of text: mirrored in right-to-left languages (base.css). */
const DIRECTIONAL: ReadonlySet<IconName> = new Set(['back', 'plane']);

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 24,
  ...rest
}: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={WIDTH[name]}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={
        DIRECTIONAL.has(name) ? `icon-dir${rest.className ? ` ${rest.className}` : ''}` : rest.className
      }
    >
      {PATHS[name]}
    </svg>
  );
}
